import { render, staticRenderFns } from "./BuyerVoucherPersonalizedForm.vue?vue&type=template&id=556b1c81&scoped=true"
import script from "./BuyerVoucherPersonalizedForm.vue?vue&type=script&lang=js"
export * from "./BuyerVoucherPersonalizedForm.vue?vue&type=script&lang=js"
import style0 from "./BuyerVoucherPersonalizedForm.vue?vue&type=style&index=0&id=556b1c81&prod&lang=css&scoped=true"
import style1 from "./BuyerVoucherPersonalizedForm.vue?vue&type=style&index=1&id=556b1c81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556b1c81",
  null
  
)

export default component.exports